import { STATUSES } from "./STATUSES";

export default function LeadsByStatusBar({ leads }) {
  const counts = STATUSES.map(
    (status) => leads.filter((l) => l.status === status.value).length
  );
  const max = Math.max(1, ...counts);
  const total = counts.reduce((a, b) => a + b, 0) || 1;

  return (
    <div className="bg-white rounded-2xl border border-blue-50 shadow-sm p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="font-semibold text-slate-900 text-sm md:text-base">
          Leads by Status
        </h2>
        <span className="text-[11px] px-2 py-1 rounded-full bg-slate-50 text-slate-600 border border-slate-100">
          Distribution
        </span>
      </div>
      <div className="space-y-2 text-xs md:text-sm">
        {STATUSES.map((status, idx) => {
          const value = counts[idx];
          const percentOfMax = Math.round((value / max) * 100);
          const shareOfTotal = Math.round((value / total) * 100);

          // Status colors based on value
          const barColor =
            status.value === "won"
              ? "from-emerald-400 to-emerald-600"
              : status.value === "in progress"
              ? "from-amber-400 to-amber-600"
              : status.value === "lost"
              ? "from-red-400 to-red-600"
              : "from-sky-400 to-sky-600"; // default for "new"

          return (
            <div key={status.value} className="flex items-center gap-2">
              <div className="w-20 text-slate-600">{status.label}</div>
              <div className="flex-1 bg-slate-100 rounded-full h-2 overflow-hidden">
                <div
                  className={"h-2 rounded-full bg-gradient-to-r " + barColor}
                  style={{ width: percentOfMax + "%" }}
                ></div>
              </div>
              <div className="w-10 text-right text-slate-500">
                {shareOfTotal}%
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
